/** @jsx React.DOM */
'use strict';

var React = require('react'),
    Dustbin = require('./Dustbin'),
    Item = require('./Item');

var Container = React.createClass({displayName: 'Container',
  render:function() {
    return (
      React.createElement("div", null, 
        React.createElement(Dustbin, null), 
        React.createElement("div", {style: { marginTop: '2rem'}}, 
          React.createElement(Item, {name: "Glass"}), 
          React.createElement(Item, {name: "Banana"}), 
          React.createElement(Item, {name: "Paper"})
        )
      )
    );
  }
});

module.exports = Container;


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-simple/Container.js
 ** module id = 143
 ** module chunks = 0
 **/